<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import type { SectionStoryblok } from "$types/components";

  export let blok: SectionStoryblok;

  const outerPaddingTop = blok.outerPaddingTop || blok.paddingTop;

  $: containedSection = blok.containedSection || false;
  $: mobileContainedSection = blok.mobileContainedSection || false;
</script>

<div
  class={`
    section-wrapper
    ${(blok?.background?.length ?? 0) > 0 ? `pt-${outerPaddingTop}` : "!pt-0"}
  `}
>
  <section
    class={containedSection
      ? `section section-contained ${
          mobileContainedSection ? "section-contained-mobile" : ""
        }`
      : ""}
  >
    <section
      class={`
        section
        relative
        px-0
        pt-${blok.paddingTop}
        pb-${blok.paddingBottom}
        ${
          !blok.rounded && blok.background
            ? `bg-[rgb(var(${blok.background}))]`
            : ""
        }
        ${blok.background === "--color-blue-primary" ? "text-white" : ""}
      `}
      use:storyblokEditable={blok}
    >
      {#if blok.rounded && blok.background}
        <div
          class={`
            md:mx-[20px]
            md:rounded-[var(--border-radius-section)]
            absolute
            inset-0
            bg-[rgb(var(${blok.background}))]
            pointer-events-none
          `}
        />
      {/if}

      <div
        class="section-header-width relative"
        class:vertical-gap={blok.verticalGap != null}
        class:gap-0={blok.verticalGap === "none"}
        class:gap-2={blok.verticalGap === "xsmall"}
        class:gap-4={blok.verticalGap === "small"}
        class:gap-6={blok.verticalGap === "medium"}
        class:gap-8={blok.verticalGap === "large"}
        class:gap-12={blok.verticalGap === "extra-large"}
        class:gap-20={blok.verticalGap === "2x-extra-large"}
        class:max-md:px-0={blok.noMobileSidePadding}
      >
        {#if blok?.content}
          {#each blok.content as content}
            <StoryblokComponent blok={content} />
          {/each}
        {/if}
      </div>
    </section>
  </section>
</div>

<style lang="postcss">
  .section,
  .section-wrapper {
    width: 100%;
    padding-top: 96px;
    position: relative;
    z-index: 5;
    overflow-x: hidden;

    @screen md {
      padding-top: 120px;
    }
    @screen lg {
      padding-top: 180px;
    }

    &.pt-none {
      padding-top: 0;
    }
    &.pb-none {
      padding-bottom: 0;
    }

    &.pt-xsmall {
      padding-top: 20px;

      @screen md {
        padding-top: 30px;
      }
      @screen lg {
        padding-top: 40px;
      }
    }
    &.pb-xsmall {
      padding-bottom: 20px;
      @screen md {
        padding-bottom: 30px;
      }
      @screen lg {
        padding-bottom: 40px;
      }
    }

    &.pt-small {
      padding-top: 48px;

      @screen md {
        padding-top: 60px;
      }
      @screen lg {
        padding-top: 90px;
      }
    }
    &.pb-small {
      padding-bottom: 48px;
      @screen md {
        padding-bottom: 60px;
      }
      @screen lg {
        padding-bottom: 90px;
      }
    }

    &.pt-mid,
    &.pt-medium {
      padding-top: 64px;
      @screen md {
        padding-top: 80px;
      }
      @screen lg {
        padding-top: 120px;
      }
    }
    &.pb-mid,
    &.pb-medium {
      padding-bottom: 64px;
      @screen md {
        padding-bottom: 80px;
      }
      @screen lg {
        padding-bottom: 120px;
      }
    }
  }

  .section-wrapper {
    .section-contained-mobile {
      padding: 0 var(--grid-padding-mobile);
    }
    .section-contained {
      @screen lg {
        padding: 0 calc(4rem - 20px);
      }

      @screen xl {
        padding: 0 calc(var(--grid-padding) - 20px);
      }
    }
  }

  .vertical-gap {
    display: flex;
    flex-direction: column;
  }
</style>
